module.exports = __webpack_public_path__ + "img/background-destination-mobile.3a7c33c5.jpg";